import { useEffect, useState, useContext } from "react";  
import './../../../index.css'
import systemContext from "../../../_context/systemContext";
import { Modal, Spinner } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { vscService } from "../../../_services/vscService";
import { FaEdit, FaTrash, FaPlus, FaCheck, FaTimes, FaUserSlash, FaUserCheck } from "react-icons/fa";
import { Tooltip } from 'react-tooltip';
import UsuarioModal from "../Modales/ModalUsuarios";
import '../../../DataTable.css';
import Swal from 'sweetalert2';
import BreadcrumbCatalogos from './BreadcrumbCatalogos';

const Usuarios = () => {    
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const [datos, setDatos] = useState([]);
    const [perfiles, setPerfiles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filterText, setFilterText] = useState('');
    // Estados para el modal
    const [showModal, setShowModal] = useState(false);
    const [usuarioEdit, setUsuarioEdit] = useState(null);
    const [modalLoading, setModalLoading] = useState(false);

    // Columnas para React Data Table
    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
            wrap: true,
            width: '80px'
        },
        {
            name: 'Nombre',
            selector: row => row.nombre,
            sortable: true,
            wrap: true,
            minWidth: '200px',
        },
        {
            name: 'Email',
            selector: row => row.email,
            sortable: true,
            wrap: true,
            minWidth: '250px',
        },
        {
            name: 'Perfil',
            selector: row => {
                const perfil = perfiles.find(p => p.id === row.idPerfil);
                return perfil ? perfil.descripcion : 'Sin perfil';
            },
            sortable: true,
            wrap: true,
            width: '150px',
        },
        {
            name: 'Fecha Creación',
            selector: row => new Date(row.fechaCreacion).toLocaleDateString(),
            sortable: true,
            wrap: true,
            width: '130px',
        },
        {
            name: 'Estatus',
            selector: row => row.activo ? 1 : 0, // Esto permite ordenar por el valor numérico
            sortable: true,
            wrap: true,
            width: '100px',
            cell: row => (
                <span className={`badge ${row.activo ? 'bg-success' : 'bg-danger'}`}>
                    {row.activo ? <FaCheck className="me-1" /> : <FaTimes className="me-1" />}
                    {row.activo ? 'Activo' : 'Inactivo'}
                </span>
            ),
        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="nova-grid-actions">
                    <button 
                        className="nova-btn-action nova-btn-edit"
                        onClick={() => handleEdit(row)}
                        data-tooltip-id="edit-tooltip"
                        data-tooltip-content="Editar usuario"
                    >
                        <FaEdit className="nova-action-icon" />
                    </button>
                    {/* Cambiamos el botón de eliminar por desactivar/reactivar */}
                    {row.activo ? (
                        <button 
                            className="nova-btn-action nova-btn-warning"
                            onClick={() => handleToggleActivo(row)}
                            data-tooltip-id="deactivate-tooltip" 
                            data-tooltip-content="Desactivar usuario"
                        >
                            <FaUserSlash className="nova-action-icon" />
                        </button>
                    ) : (
                        <button 
                            className="nova-btn-action nova-btn-success"
                            onClick={() => handleToggleActivo(row)}
                            data-tooltip-id="activate-tooltip" 
                            data-tooltip-content="Activar usuario"
                        >
                            <FaUserCheck className="nova-action-icon" />
                        </button>
                    )}
                </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: '120px',
        },
    ];

    // Filtrado de datos
    const filteredItems = datos.filter(item =>
        item.nombre?.toLowerCase().includes(filterText.toLowerCase()) ||
        item.email?.toLowerCase().includes(filterText.toLowerCase())
    );

    // Estilos personalizados para la tabla
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: 'var(--primary-color)',
                color: 'white',
                fontSize: '0.9rem',
                fontWeight: '600',
                minHeight: '50px',
                borderBottom: '2px solid rgba(255, 255, 255, 0.3)',
            },
        },
        headCells: {
            style: {
                paddingLeft: '12px',
                paddingRight: '12px',
                fontSize: '0.85rem',
                fontWeight: '600',
            },
        },
        cells: {
            style: {
                paddingLeft: '10px',
                paddingRight: '10px',
                fontSize: '0.75rem',
                color: 'var(--text-dark)',
            },
        },
        rows: {
            style: {
                fontSize: '0.75rem',
                minHeight: '30px',
                maxHeight: '30px', 
                '&:nth-child(even)': {
                    backgroundColor: 'rgba(0, 50, 139, 0.02)',
                },
                '&:hover': {
                    backgroundColor: 'rgba(0, 50, 139, 0.05) !important',
                },
            },
            stripedStyle: {
                backgroundColor: 'rgba(0, 50, 139, 0.02)',
            },
        },
        pagination: {
            style: {
                fontSize: '0.7rem',
                borderTop: '1px solid rgba(0, 50, 139, 0.1)',
                color: 'var(--text-dark)',
            },
        },
    };

    // Opciones de paginación en español
    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    // Componente de búsqueda
    const subHeaderComponent = (
        <div className="nova-table-search">
            <input
                type="text"
                placeholder="Buscar por nombre o email..."
                className="nova-search-input"
                value={filterText}
                onChange={e => setFilterText(e.target.value)}
            />
            <div className="nova-search-results">
                {filteredItems.length} de {datos.length} registros
            </div>
        </div>
    );

    // Componente cuando no hay datos
    const NoDataComponent = () => (
        <div className="nova-no-data">
            <div className="nova-no-data-icon">👥</div>
            <h3>No se encontraron usuarios</h3>
            <p>No hay usuarios registrados en el sistema.</p>
        </div>
    );

    useEffect(() => {
        getUsuarios();
        getPerfiles();
    }, []);

    const getUsuarios = async () => {
        try {
            setLoading(true);
            const respuesta = await vscService.getUsuarios();
            if (respuesta.status === "OK") {
                const datos = respuesta.content.usuarios || respuesta.content.data || respuesta.data || [];
                setDatos(datos);
            } else {
                throw new Error(respuesta.message || 'Error al cargar usuarios');
            }
        } catch (error) {
            console.error('Error en obtener usuarios:', error);
            setDatos([]);
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar los usuarios.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setLoading(false);
        }
    };

    const getPerfiles = async () => {
        try {
            const respuesta = await vscService.getPerfiles();
            if (respuesta.status === "OK") {
                const perfilesData = respuesta.content.perfiles || respuesta.content.data || respuesta.data || [];
                setPerfiles(perfilesData);
            }
        } catch (error) {
            console.error('Error al cargar perfiles:', error);
        }
    };

    // Handlers
    const handleAddNew = () => {
        setUsuarioEdit(null);
        setShowModal(true);
    };

    const handleEdit = (usuario) => {
        setUsuarioEdit(usuario);
        setShowModal(true);
    };

    // Nuevo handler para desactivar/reactivar usuarios
    const handleToggleActivo = async (usuario) => {
        const accion = usuario.activo ? 'desactivar' : 'activar';
        const accionTexto = usuario.activo ? 'desactivado' : 'activado';
        
        const result = await Swal.fire({
            title: `¿Estás seguro?`,
            text: `¿Quieres ${accion} al usuario "${usuario.nombre}"? ${usuario.activo ? 'El usuario ya no podrá acceder al sistema.' : 'El usuario podrá acceder nuevamente al sistema.'}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: usuario.activo ? '#ffc107' : '#28a745',
            cancelButtonColor: '#6c757d',
            confirmButtonText: usuario.activo ? 'Sí, desactivar' : 'Sí, activar',
            cancelButtonText: 'Cancelar',
            reverseButtons: true,
            customClass: {
                popup: 'nova-swal-popup',
                confirmButton: 'nova-swal-confirm',
                cancelButton: 'nova-swal-cancel'
            }
        });

        if (result.isConfirmed) {
            setLoading(true);
            try {
                // Preparar datos para actualizar
                const usuarioData = {
                    id: usuario.id,
                    nombre: usuario.nombre,
                    email: usuario.email,
                    fechaCreacion: usuario.fechaCreacion,
                    activo: usuario.activo ? 0 : 1, // Cambiar el estado
                    idPerfil: usuario.idPerfil
                };

                const resultado = await vscService.putEditaUsuario(usuarioData);
                
                if (resultado.status === "OK" || resultado.success) {
                    await getUsuarios(); // Recargar la lista
                    await Swal.fire({
                        position: "top-end",
                        icon: "success",
                        title: `Usuario ${accionTexto} con éxito.`,
                        showConfirmButton: false,
                        timer: 1500,
                        customClass: {
                            popup: 'nova-swal-popup'
                        }
                    });
                } else {
                    throw new Error(resultado.message || `Error al ${accion} usuario`);
                }
            } catch (error) {
                console.error(`Error al ${accion} usuario:`, error);
                await Swal.fire({
                    position: "top-end",
                    icon: "error",
                    title: `Error al ${accion} el usuario.`,
                    text: error.message || "Por favor, intenta nuevamente.",
                    showConfirmButton: false,
                    timer: 2000,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } finally {
                setLoading(false);
            }
        }
    };

    const handleSaveUsuario = async (formData) => {
        setModalLoading(true);
        try {
            // Preparar datos según el JSON especificado
            const usuarioData = {
                id: usuarioEdit?.id || 0,
                nombre: formData.nombre,
                email: formData.email,
                fechaCreacion: usuarioEdit?.fechaCreacion || new Date().toISOString(),
                activo: formData.activo,
                idPerfil: parseInt(formData.idPerfil)
            };

            let resultado;
            
            if (usuarioEdit?.id) {
                // Modo edición
                resultado = await vscService.putEditaUsuario(usuarioData);
            } else {
                // Modo creación
                resultado = await vscService.postInsertaUsuario(usuarioData);
            }

            if (resultado.status === "OK" || resultado.success) {
                await getUsuarios();
                setShowModal(false);
                setUsuarioEdit(null);
                await Swal.fire({
                    position: "top-end",
                    icon: "success",
                    title: usuarioEdit?.id ? "Usuario actualizado con éxito." : "Usuario creado con éxito.",
                    showConfirmButton: false,
                    timer: 1500,
                    customClass: {
                        popup: 'nova-swal-popup'
                    }
                });
            } else {
                throw new Error(resultado.message || 'Error en la operación');
            }
        } catch (error) {
            console.error('Error al guardar usuario:', error);
            await Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al guardar el usuario.",
                text: error.message || "Por favor, intenta nuevamente.",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
        } finally {
            setModalLoading(false);
        }
    };

    return (
        <div className="nova-dashboard-balanced">
            {/* Header de la página */}
            <div className="nova-page-header">
                <h3 className="nova-page-title">Catálogo de Usuarios</h3>
                <div className="nova-header-actions-right">
                    <BreadcrumbCatalogos />
                <button 
                    className="nova-btn-primary"
                    onClick={handleAddNew}
                >
                    <FaPlus className="me-2" />
                    Agregar Nuevo Usuario
                </button>
                </div>
            </div>

            {/* Contenedor de la tabla */}
            <div className="nova-data-table-container">
                <DataTable
                    columns={columns}
                    data={filteredItems}
                    customStyles={customStyles}
                    className="nova-react-datatable"
                    pagination
                    paginationPerPage={10}
                    paginationRowsPerPageOptions={[10, 25, 50]}
                    paginationComponentOptions={paginationComponentOptions}
                    progressPending={loading}
                    progressComponent={
                        <div className="nova-grid-loading">
                            <Spinner animation="border" role="status" />
                            <p>Cargando usuarios...</p>
                        </div>
                    }
                    subHeader
                    subHeaderComponent={subHeaderComponent}
                    noDataComponent={<NoDataComponent />}
                    highlightOnHover
                    striped
                    responsive
                    fixedHeader
                    fixedHeaderScrollHeight="700px"
                    persistTableHead
                />
            </div>

            {/* Modal para crear/editar */}
            <UsuarioModal
                show={showModal}
                onHide={() => setShowModal(false)}
                usuario={usuarioEdit}
                perfiles={perfiles}
                onSave={handleSaveUsuario}
                loading={modalLoading}
            />

            {/* Tooltips */}
            <Tooltip id="edit-tooltip" place="top" />
            <Tooltip id="deactivate-tooltip" place="top" />
            <Tooltip id="activate-tooltip" place="top" />
        </div>
    );
};

export default Usuarios;